<template>
  <div class="signin position-relative">
    <div class="d-flex flex-column mt-3 mb-3 ml-4 mr-4">
      <div class="d-flex justify-content-center">
        <div class="d-flex flex-row align-items-center mb-3">
          <Logo/>
          <h1 class="ml-3 mr-1">Password Reset</h1>
        </div>
      </div>
      <h2 class="modal-subtitle mx-auto mb-4">Please choose a new password.</h2>
      <form class="d-flex justify-content-center" autocomplete="off">
        <input class="mb-2 mx-auto" type="password" v-model="password" placeholder="New password" autocomplete="new-password" />
      </form>
      <p class="validation-error mb-2" v-if="showError">{{errorMessage}}</p>
      <div class="contact d-flex justify-content-center mb-3 pl-2 pr-2">
        <span v-if="showError">
          <span>Drop us a line at </span>
          <a href="mailto:support@aftv.co.uk" target="_blank">support@aftv.co.uk</a>
          <span> if you have problems with sign-in or registration</span>
        </span>
      </div>
      <div class="d-flex justify-content-center">
        <button class="secondary" width="auto" v-on:click="onClose">Cancel</button>
        <button class="primary" width="auto" v-on:click="onSave">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '../components/Logo.vue'
import { spinnakerApi } from '../js/SpinnakerApi.js'

const errUnexpectedError = 'Failed to perform password reset. Please try again later.'
const errMissingPassword = 'Please enter a new password.'

export default {
  components: {
    Logo
  },
  props: ['token'],
  name: 'PasswordResetPerform',
  data: function () {
    return {
      showError: false,
      errorMessage: errMissingPassword,
      password: ''
    }
  },
  methods: {
    onClose () {
      this.$modal.hide('password-reset-perform-modal')
    },
    async onSave () {
      if (this.password === '') {
        this.errorMessage = errMissingPassword
        this.showError = true
        return
      }

      this.$store.commit('showLoading')

      try {
        await spinnakerApi.passwordResetPerform(this.token, this.password)

        this.$modal.hide('password-reset-perform-modal')
        this.$store.commit('hideLoading')

        this.$store.commit('startSignIn', 'PASSWORD_RESET')
      } catch (err) {
        this.sendFailed(err)
      }
    },
    sendFailed (err) {
      this.$store.commit('hideLoading')
      this.$store.commit('isRegisteredUser', false)

      this.errorMessage = errUnexpectedError
      this.showError = true
      if (err && err.response && err.response.status === 400 &&
          err.response.data && err.response.data.errorCode) {
        this.errorMessage += ` [${err.response.data.errorCode}]`
      }
    }
  }
}
</script>

<style scoped></style>
